// extracted by mini-css-extract-plugin
export default {"wrapper":"CX-z","availablePromoMessagesLabel":"DX-z","promoMessageList":"EX-z","promoMessage":"FX-z","appliedPromoMessage":"GX-z","promoMessageAmount":"HX-z"};